import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

import { Typography } from "@/components/ui-v2";
import { TwoDIcon } from "@/components/ui-v2/icons";

interface SessionItemProps {
  to: string;
  name?: string;
  iconUrl?: string;
}

const Container = styled(Link)(({ theme }) => ({
  height: theme.spacing(9),
  position: "relative",
  display: "flex",
  flexGrow: 1,
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1),
  borderRadius: theme.spacing(1),
  color: theme.palette.secondary[3],
  overflow: "clip",
  border: "none",
  boxShadow: "inset 0 0 0 0.5px transparent",
  paddingRight: theme.spacing(3),

  "&:hover": {
    backgroundColor: theme.palette.secondary[7],
    boxShadow: `inset 0 0 0 0.5px ${theme.palette.secondary[6]}`,
  },

  "&:last-of-type": {
    marginBottom: 0,
  },
}));

const SessionIcon = styled("img")(({ theme }) => ({
  borderRadius: 3,
  backgroundColor: theme.palette.secondary[3],
  width: theme.spacing(4),
  height: theme.spacing(4),
  flexShrink: 0,
}));

const IconContainer = styled("span")(({ theme }) => ({
  display: "flex",
  width: theme.spacing(9),
  height: theme.spacing(9),
  borderRadius: 4,
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.secondary[3],
  flexShrink: 0,
}));

const SessionNoIconContainer = styled("span")(({ theme }) => ({
  width: theme.spacing(5.5),
  height: theme.spacing(5.5),
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const SessionItem = (props: SessionItemProps) => {
  const { to, name, iconUrl } = props;

  return (
    <Container to={to}>
      <IconContainer>
        {iconUrl ? (
          <SessionIcon src={iconUrl} alt={name} />
        ) : (
          <SessionNoIconContainer>
            <TwoDIcon sx={{ width: "100%" }} />
          </SessionNoIconContainer>
        )}
      </IconContainer>
      <Typography variant="small" noWrap>
        {name}
      </Typography>
    </Container>
  );
};
